import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Footer from "./Footer"

const ImageUploadRules = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="container">
      <button onClick={() => window.history.back()} className="back-btn">
        <ArrowLeft size={20} />
        back
      </button>

      <div className="card">
        <h1 className="title">Image Upload Rules</h1>
        <p className="lead">
          Please read this page before uploading any images to <strong>elo-baord.com</strong>. 
          These rules are designed to keep our community safe and lawful.
        </p>
        <p className="muted small">
          Last updated: 30 August 2025
        </p>

        <div className="grid two">
          <div className="info-card">
            <h2>Quick checklist</h2>
            <ul className="checklist">
              <li>You created the image or have permission to use and share it.</li>
              <li>No personal data is shared without consent (faces, IDs, private info).</li>
              <li>No illegal, harmful, or offensive content.</li>
              <li>Your upload follows the file/size limits and naming rules.</li>
              <li>You agree that we may host, display, and process the image to run the service.</li>
            </ul>
          </div>
          <div className="info-card">
            <h2>At a glance</h2>
            <ul className="list-tight block">
              <li><span className="badge">Formats</span> JPEG, PNG, WebP, GIF.</li>
              <li><span className="badge">Max size</span> Up to <strong>5MB</strong> per file.</li>
            </ul>
          </div>
        </div>

        <div className="section-card">
          <h2>1) Ownership & licence</h2>
          <p>
            You keep the copyright in your images. By uploading, you grant <strong>elo-board.com</strong> a{' '}
            <em>non‑exclusive, worldwide, royalty‑free</em> licence to host, store, display, reproduce, 
            and technically process your images for the purpose of operating, promoting, and improving 
            the service. You confirm you have the necessary rights and permissions for everything you upload.
          </p>
        </div>

        <div className="section-card">
          <h2>2) What you must not upload</h2>
          <ul className="list-tight block">
            <li>Content that infringes copyright, trademarks, or other rights (including unlicensed stock photos, logos, or images copied from the web).</li>
            <li>Images that are unlawful, including extreme or unlawful violence, or terrorist content.</li>
            <li>Harassing, hateful, or discriminatory content targeting protected characteristics.</li>
            <li>Private or personal information without permission (e.g. faces, addresses, phone numbers, financial or health data).</li>
            <li>Intimate images or images taken/used without consent.</li>
            <li>Defamatory or misleading content presented as factual about real people.</li>
            <li>Anything that violates these rules, our Terms of Use, or applicable platform/provider policies.</li>
          </ul>
        </div>

        <div className="section-card">
          <h2>3) How to upload properly</h2>
          <ol className="list-tight">
            <li>Make sure you own the rights or have explicit permission to upload and share.</li>
            <li>Remove or blur private details if not necessary (faces, addresses, plates).</li>
            <li>Use supported formats and keep to the size limits.</li>
            <li>Provide accurate titles/captions if requested; do not mislead viewers.</li>
            <li>Only upload once; do not spam or create duplicates.</li>
          </ol>
        </div>

        <div className="section-card">
          <h2>4) Moderation & takedown</h2>
          <p>
            We may remove or restrict access to images that appear to break the law or these rules.
          </p>
          <p>
            If you believe your rights are infringed or content is unlawful, please send a detailed 
            notice to <strong><a href="mailto:[support@elo-baord.com]">[support@elo-baord.com]</a></strong> so we can 
            assess and act quickly.
          </p>
          <h3>What to include in a notice</h3>
          <ul className="list-tight block small">
            <li>Links to the exact image(s) and a description of the issue.</li>
            <li>Why you believe it is unlawful or infringing (e.g., you are the copyright owner).</li>
            <li>Your name, organisation (if any), and contact details.</li>
            <li>A statement that the information in your notice is accurate and that you are authorised to act.</li>
          </ul>
        </div>

        <div className="section-card">
          <h2>5) Removal, retention & backups</h2>
          <ul className="list-tight block">
            <li>You can request deletion of your images at any time. Caches and backups may take a short period to clear.</li>
          </ul>
        </div>

        <div className="section-card">
          <h2>6) Your promises to us</h2>
          <ul className="list-tight block">
            <li>You have the rights and permissions to upload and share each image.</li>
            <li>Your upload complies with these rules.</li>
          </ul>
        </div>

        <div className="section-card">
          <h2>7) Changes & contact</h2>
          <p>
            We may update these rules from time to time. We will post changes on this page and 
            update the date above.
          </p>
          <p>
            Questions or problems? Email us at <strong><a href="mailto:[support@elo-baord.com]">[support@elo-baord.com]</a></strong>.
          </p>
        </div>

        <br />
      </div>
            <Footer />
    </div>
  );
};

export default ImageUploadRules;